import { connect } from 'react-redux';

import { getIsAdmin } from 'src/store/client/selectors';
import {
  getTourOperatorLinkById,
  getTourOperatorNameById,
} from '../../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { OperatorDetails } from './OperatorDetails';

const mapStateToProps = (state, props: { tourId: string }) => ({
  operatorName: getTourOperatorNameById(state, props.tourId),
  bookingUrl: getTourOperatorLinkById(state, props.tourId),
  isLoggedUser: getIsAdmin(state),
});

export default connect(mapStateToProps)(OperatorDetails);
